/* Shared keyboard behavior for non-modal flyouts and product information dialogs.
 * Tab is deliberately not trapped. Leaving the dialog dismisses it without
 * taking focus away from the next control; Escape and Close return to the opener.
 */
(function () {
  'use strict';
  var active = null;

  // Programmatic focus after an iOS tap can still match :focus-visible.
  // Track actual input without blurring controls or removing keyboard access.
  function pointerFocus() {
    document.documentElement.setAttribute('data-focus-input', 'pointer');
  }
  document.addEventListener('pointerdown', pointerFocus, true);
  document.addEventListener('touchstart', pointerFocus, {capture: true, passive: true});
  document.addEventListener('mousedown', pointerFocus, true);
  document.addEventListener('keydown', function (event) {
    if (!event.altKey && !event.ctrlKey && !event.metaKey &&
        ['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
         'Home', 'End', 'Enter', ' ', 'Escape'].indexOf(event.key) !== -1) {
      document.documentElement.setAttribute('data-focus-input', 'keyboard');
    }
  }, true);


  function firstControl(dialog, selector) {
    if (selector) {
      var preferred = dialog.querySelector(selector);
      if (preferred && !preferred.disabled) return preferred;
    }
    return Array.prototype.find.call(
      dialog.querySelectorAll('a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]'),
      function (element) {
        return !element.disabled && element.tabIndex >= 0 &&
          !element.closest('[hidden]') && element.getClientRects().length > 0;
      }
    ) || dialog;
  }

  function updateHeaderName(trigger) {
    if (!trigger) return;
    var name = {BtnMenu: 'Menu', BtnSearch: 'Search', BtnCart: 'Cart'}[trigger.id];
    if (!name) return;
    if (trigger.getAttribute('aria-expanded') === 'true') {
      trigger.setAttribute('aria-label', 'Close ' + name.toLowerCase());
    } else if (trigger.id === 'BtnCart') {
      var count = trigger.querySelector('.CartCount');
      var quantity = count ? count.textContent.trim() : '0';
      trigger.setAttribute('aria-label', 'Cart, ' + quantity + (quantity === '1' ? ' item' : ' items'));
    } else {
      trigger.setAttribute('aria-label', name);
    }
  }

  window.ErieAccessibility = {
    open: function (dialog, trigger, dismiss, initialSelector) {
      if (!dialog) return;
      if (active && active.dialog !== dialog) active.dismiss(false);
      dialog.hidden = false;
      dialog.style.display = 'block';
      dialog.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      updateHeaderName(trigger);
      active = {dialog: dialog, trigger: trigger, dismiss: dismiss};
      firstControl(dialog, initialSelector).focus();
    },
    close: function (dialog, restoreFocus) {
      if (!dialog) return;
      var closing = active && active.dialog === dialog ? active : null;
      if (closing) active = null;
      dialog.hidden = true;
      dialog.style.display = 'none';
      dialog.setAttribute('aria-hidden', 'true');
      var trigger = closing ? closing.trigger : document.querySelector('[aria-controls="' + dialog.id + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      updateHeaderName(trigger);
      if (closing && restoreFocus !== false && trigger && trigger.isConnected) trigger.focus();
    }
  };

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && active) {
      event.preventDefault();
      active.dismiss();
    }
  });

  document.addEventListener('focusin', function (event) {
    if (!active || active.dialog.contains(event.target)) return;
    // The existing header controls may toggle or switch panels. Do not close
    // on their preceding focus event and accidentally reopen on their click.
    if (event.target.closest('#BtnMenu, #BtnSearch, #BtnCart, .TooltipTrigger')) return;
    active.dismiss(false);
  });

  function updateCartName() {
    var button = document.getElementById('BtnCart');
    var count = button && button.querySelector('.CartCount');
    if (!count) return;
    function update() {
      updateHeaderName(button);
    }
    update();
    new MutationObserver(update).observe(count, {childList: true, characterData: true, subtree: true});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartName);
  } else {
    updateCartName();
  }
})();
